import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ApproveAttendanceParameters, unapproveAttendance } from 'src/api/attendanceAPI';
import ApiError from 'src/api/errorHandling/ApiError';

export default function useUnapproveAttendance() {
  const queryClient = useQueryClient();

  return useMutation<void, ApiError, ApproveAttendanceParameters>(async parameters => {
    await unapproveAttendance(parameters);
    queryClient.invalidateQueries(['attendance']);
    queryClient.invalidateQueries(['SigningFormPage']);
  });
}
